const OverviewPage = () => (
  <section>
    <h1>Overview</h1>
    <p>
      This bootstrap establishes the Unified API Governance Portal shell and the
      base page structure for Design API and Review Spec flows.
    </p>
  </section>
);

export default OverviewPage;
